import { Card } from '../../components';

export function DeviceCodeSuccessPage(): JSX.Element {
  return (
    <Card header={<h2 className="text-2xl font-medium leading-6 text-gray-900">Device Authorized</h2>}>
      <div className="flex flex-col gap-4 p-2">
        <div className="rounded-md bg-green-50 border border-green-200 p-3">
          <p className="text-sm text-green-700">
            The device has been successfully authorized. You can close this window.
          </p>
        </div>
      </div>
    </Card>
  );
}
